import React from "react";
import { Box, Grid2 } from "@mui/material";
import { Add, Save, Edit, Print, DateRange } from "@mui/icons-material";
import GenericActionButton from "./GenericActionButton";

const MenuBar = ({
  onNew,
  onSave,
  onEdit,
  onPrint,
  onDateRangeFilter,
  showNew = false,
  showSave = false,
  showEdit = false,
  showPrint = false,
  showDateRangeFilter = false,
  disabled = false,
}) => (
  <Grid2 container size={12} pb={0.5} pt={0.5} pl={1}  sx={{ borderBottom: "2px solid lightgray", width: "100%" }}  spacing={1}>
    {showNew && (
      <GenericActionButton
        label="New"
        icon={<Add />}
        onClick={onNew}
        disabled={disabled}
        tooltipText="Create New"
      />
    )}
    {showSave && (
      <GenericActionButton
        label="Save"
        icon={<Save />}
        onClick={onSave}
        disabled={disabled}
        tooltipText="Save"
      />
    )}
    {showEdit && (
      <GenericActionButton
        label="Edit"
        icon={<Edit />}
        onClick={onEdit}
        disabled={disabled}
        tooltipText="Edit"
      />
    )}
    {showPrint && (
      <GenericActionButton
        label="Print"
        icon={<Print />}
        onClick={onPrint}
        disabled={disabled}
        tooltipText="Print"
      />
    )}
    {showDateRangeFilter && (
      <GenericActionButton
        label="Date Range"
        icon={<DateRange />}
        onClick={onDateRangeFilter}
        disabled={disabled}
        tooltipText="Filter by Date Range"
      />
    )}
  </Grid2>
);

export default MenuBar;